var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownArrowDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.9974 18.3332C14.5998 18.3332 18.3307 14.6022 18.3307 9.99984C18.3307 5.39746 14.5998 1.6665 9.9974 1.6665C5.39502 1.6665 1.66406 5.39746 1.66406 9.99984C1.66406 14.6022 5.39502 18.3332 9.9974 18.3332Z",
    fill: "#E7EAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99427 12.5084C9.83594 12.5084 9.6776 12.4501 9.5526 12.3251L6.61094 9.38343C6.36927 9.14176 6.36927 8.74176 6.61094 8.5001C6.8526 8.25843 7.2526 8.25843 7.49427 8.5001L9.99427 11.0001L12.4943 8.5001C12.7359 8.25843 13.1359 8.25843 13.3776 8.5001C13.6193 8.74176 13.6193 9.14176 13.3776 9.38343L10.4359 12.3251C10.3109 12.4501 10.1526 12.5084 9.99427 12.5084Z",
    fill: "#E7EAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowDark);
export default __webpack_public_path__ + "static/media/dropdown-arrow-dark.2f22c6062e052aea619789c697c0feca.svg";
export { ForwardRef as ReactComponent };